import PropTypes from 'prop-types';
import {
    Avatar,
    Box,
    Button,
    ButtonBase,
    MenuItem,
    Menu,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions, CircularProgress
} from '@mui/material';
import {toast} from "react-toastify";
import {useRecoilValue} from "recoil";
import {useNavigate} from "react-router";
import LogoSection from '../LogoSection';
import {useState, useEffect} from 'react';
import { IconMenu2 } from '@tabler/icons';
import ProfileSection from './ProfileSection';
import { useTheme } from '@mui/material/styles';
import {configState} from "../../../recoil/atoms";
import {GetSessionTotalResponse, SessionsApi} from "../../../api/auth";


const Header = ({ handleLeftDrawerToggle } :any) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const config = useRecoilValue(configState);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [data, setData]= useState<GetSessionTotalResponse | undefined>();

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setAnchorEl(null);
    };

    const handleDialogAgree = () =>{
        localStorage.removeItem("AccessToken");
        logoutSessions();
        navigate("login");
    };

    const logoutSessions = () => {
        const session = new SessionsApi(config);
        session.sessionsLogout()
            .then((res)=>{
                toast.success(res?.data?.Message!);
            }).catch((err)=>{
            toast.error(err?.response?.data?.detail);
        });
    };

    useEffect(() => {        
        const sessionsApi = new SessionsApi(config);
        sessionsApi.getSessionsTotal()
            .then((res) => {
                setData(res.data);
            })
            .catch((err) => {
                toast.error(err?.response?.data?.detail);
            })
    }, [config]);

    return (
        <>
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.body1,
                            ...theme.typography.body2,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            <div>
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    Online:   {data ? data.Sessions: <CircularProgress size={20}/>}
                </Button>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={handleOpenDialog}>Logout All</MenuItem>
                </Menu>
            </div>
            <ProfileSection />
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{fontSize:"18px"}}>
                    Log out all sessions?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Log out all user sessions on this account.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Disagree</Button>
                    <Button onClick={handleDialogAgree} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
